import * as React from "react";
import { SVGProps } from "react";
const SvgLinkExternal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 24.5c0 2.5-1 3.5-3.5 3.5h-17C5 28 4 27 4 24.5v-17C4 5 5 4 7.5 4h6.001c.5 0 1 .5 1 1s-.5 1-1 1H7.5C6.5 6 6 6.5 6 7.5v17c0 1 .5 1.5 1.5 1.5h17c1.198 0 1.477-.229 1.499-1.348L26 19.5c0-.625.375-1 1-1s1 .375 1 1v5Zm2.697-21.753a25.39 25.39 0 0 1 .262 5.401l-.047.761-.065.806-.04.421-.09.885-.053.466-.118.982a1 1 0 1 1-1.984-.248l.107-.876.132-1.179.07-.71.054-.665.04-.629.024-.603c.014-.496.013-.977-.003-1.473l-.027-.603-.042-.627-.027-.327-9.987 9.987a1 1 0 0 1-1.497-1.32l.083-.094 9.991-9.991c-.221-.02-.436-.036-.645-.05l-.615-.035a23.544 23.544 0 0 0-1.774-.016l-.605.025-.311.018-.646.047-.338.03-.712.069-.77.084-1.286.155a1 1 0 1 1-.248-1.984l.981-.118.915-.1c.147-.016.292-.03.435-.044l.83-.074a38.34 38.34 0 0 1 1.523-.094l.71-.02a25.127 25.127 0 0 1 4.327.297c.75.108 1.338.697 1.446 1.446Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLinkExternal;
